export const module = {
  info: {
    name: 'app',
    caption: 'App',
  },
  vuexModules: ['state'],
  noRoutes: true
}

export default module
